// src/components/ui/ClabLogoPng.jsx
import React from 'react';

const ClabLogoPng = ({ size = 'md', className = '', showSubtext = false, src }) => {
  const sizeClasses = {
    xs: 'h-6',
    sm: 'h-8', 
    md: 'h-10',
    lg: 'h-12',
    xl: 'h-16',
    '2xl': 'h-20'
  };

  return (
    <div className={`${className} flex items-center space-x-3`}>
      <div className="relative">
        <img 
          src={src || '/assets/LOGO_CLAB.png'}
          alt="CLAB Logo"
          className={`${sizeClasses[size]} w-auto object-contain filter drop-shadow-sm`}
          onError={(e) => {
            // Fallback if image fails to load
            e.target.style.display = 'none';
            const fallback = e.target.nextElementSibling;
            if (fallback) fallback.style.display = 'flex';
          }}
        />
        {/* Fallback text logo with helmet icon */}
        <div 
          className="hidden items-center space-x-2 text-primary font-bold"
          style={{ display: 'none' }}
        >
          <div className={`bg-primary text-white rounded-full ${
            size === 'xs' ? 'w-5 h-5 text-xs' : 
            size === 'sm' ? 'w-6 h-6 text-sm' : 
            'w-8 h-8 text-base'
          } flex items-center justify-center font-bold`}>
            C
          </div>
          <span className={`${
            size === 'xs' ? 'text-sm' : 
            size === 'sm' ? 'text-base' : 
            'text-lg'
          } font-bold tracking-wide`}>
            CLAB
          </span>
        </div>
      </div>
      {showSubtext && (size === 'lg' || size === 'xl' || size === '2xl') && (
        <span className={`text-xs text-secondary-600 tracking-wider ${
          size === 'xl' || size === '2xl' ? 'text-sm' : 'text-xs'
        }`}>
          eBiodata System
        </span>
      )}
    </div>
  );
};

export default ClabLogoPng;